import { createContext, useState, useContext } from "react";

// Skapa kontexten
const SidebarContext = createContext();

// Custom hook för enkel åtkomst till SidebarContext
export const useSidebar = () => useContext(SidebarContext);

// SidebarProvider som vi kommer att använda runt hela appen
export const SidebarProvider = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  return (
    <SidebarContext.Provider value={{ isSidebarOpen, toggleSidebar }}>
      {children}
    </SidebarContext.Provider>
  );
};
